import { validator } from './validator.js';
export const pattern = (regexp) => validator((_) => typeof _ === 'string' && regexp.test(_));
//# sourceMappingURL=pattern.js.map